import { SolViewId, SolViewOptions } from '@sol/components';

export class AsmDashboardsViewId {
  public static readonly kpiSparkline = SolViewId.of<SolViewOptions>('asm.kpiSparkline');
}
